import { toAgentContextNugget } from '@backrs_ui/grow-ui/src/agentContext/toAgentContextNugget';
import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import { CATEGORY_TITLE_MAP, type BoxType } from './InfoBox.config';
import { type SortedContentItem } from './InfoBoxContent';

/**
 * Registers agent context for the resource tab the user is currently viewing:
 *   1. A `tab` entry to tell Lubav which tab is currently active.
 *   2. A `nuggetList` entry listing the items currently visible inside that tab.
 */
export const useAgentContext = (
  selectedBoxType: BoxType | undefined,
  sortedContent: readonly SortedContentItem[],
) => {
  const tabLabel = selectedBoxType ? CATEGORY_TITLE_MAP[selectedBoxType] : null;

  useRegisterAgentContext(
    tabLabel
      ? {
          kind: 'tab',
          title: tabLabel,
        }
      : null,
  );

  useRegisterAgentContext(
    selectedBoxType && tabLabel && sortedContent.length > 0
      ? {
          kind: 'nuggetList',
          description: `Items currently visible in the "${tabLabel}" tab. Use these ids when the user asks about something they're looking at.`,
          nuggets: sortedContent.map(({ item }) => toAgentContextNugget(item)),
        }
      : null,
  );
};
